export const ContactPhoneAreaItems = () => {
    return window.PHONE_PREFIXES.map((item) => item);
};
